import { isSnack } from './env';
import { sendLiveCustomLog } from '@/utils/kibtLogger';

export const serialize = function (obj: Record<string, any>) {
    const str = [];
    for (const p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p) && (obj[p] || obj[p] === 0)) {
            str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
        }
    }
    return str.join('&');
};

export const getQueryParams = function (input = '') {
    const url = input || location.search || ''; // 获取url中"?"符后的字串
    // 处理客户端直播间拼接参数出现两个问号的情况，临时处理将author_id前面的?改为&
    const str = url.substr(1).replace(/\?author_id/, '&author_id');
    const theRequest = Object.create(null);
    const strs = str.split('&').filter(Boolean);
    for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
    return theRequest;
};

export const getQuery = (name: string): string | undefined => {
    const search = location.search;
    if (!name || !search) {
        return '';
    }
    const result = search.match(new RegExp(`[?&]${name}=([^&]+)`, 'i'));
    if (result !== null && result.length > 0) {
        return result[1];
    }

    return '';
};

export function addParam(url: string, params: any) {
    const sp = url.indexOf('?') === -1 ? '?' : '&';
    return `${url}${sp}${serialize(params)}`;
}

export const sleep = (ms: number) => {
    return new Promise<void>(res => {
        setTimeout(() => {
            res();
        }, ms);
    });
};

export const padStart = (
    v: number | string,
    target: number,
    padString: string
) => {
    return `${v}`.padStart(target, padString);
};
export const isValidArray = (data: any) => {
    if (Array.isArray(data)) {
        return data.length > 0;
    }
    return false;
};

const pad = (t: string | number) => {
    return `0${t}`.slice(-2);
};

export const getCountDownText = (t: number) => {
    if (t < 0) t = 0;
    t = Math.ceil(t / 1000);
    const d = Math.floor(t / 60 / 60 / 24);
    const h = Math.floor((t / 60 / 60) % 24);
    const m = Math.floor((t / 60) % 60);
    const s = Math.floor(t % 60);
    const arr = [`${d}d`, `${pad(h)}h`, `${pad(m)}m`, `${pad(s)}s`];
    return arr.slice(d > 0 ? 0 : 1).join(' ');
};

export const getCountDownObj = (t: number) => {
    if (t < 0) t = 0;
    t = Math.ceil(t / 1000);
    const d = Math.floor(t / 60 / 60 / 24);
    const h = Math.floor((t / 60 / 60) % 24);
    const m = Math.floor((t / 60) % 60);
    const s = Math.floor(t % 60);
    const arr = [`${d}d`, `${pad(h)}h`, `${pad(m)}m`, `${pad(s)}s`];
    const obj: Record<string, string> = {
        d: arr[0],
        h: arr[1],
        m: arr[2],
        s: arr[3],
    };
    if (d < 1) {
        delete obj.d;
    }
    return obj;
};

export const getCountDownNumber = (t: number) => {
    if (t < 0) t = 0;
    t = Math.ceil(t / 1000);
    // const d = Math.floor(t / 60 / 60 / 24);
    const h = Math.floor((t / 60 / 60) % 24);
    const m = Math.floor((t / 60) % 60);
    const s = Math.floor(t % 60);
    const arr = [
    // `${d}`,  Number模式暂时不需要天
        `${pad(h)}`,
        `${pad(m)}`,
        `${pad(s)}`,
    ];
    // eg: 01:23:99
    return arr.slice(h > 0 ? 0 : 1).join(':');
};

export const parseDate = (val: number) => {
    if (!val) return {};
    const t = new Date(val);
    return {
        y: t.getFullYear().toString(),
        M: `${pad(t.getMonth() + 1)}`,
        d: `${pad(t.getDate())}`,
        h: `${pad(t.getHours())}`,
        m: `${pad(t.getMinutes())}`,
        s: `${pad(t.getSeconds())}`,
    };
};

/**
 * 比较版本号
 * @param  {string} source 比较源
 * @param  {string} target 比较目标
 * @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
 */
export const compareAppVersion = (source: any, target: any) => {
    if (!source || !target) return 0;
    const sourceArr = source.split('.');
    const targetArr = target.split('.');
    for (let i = 0; i < sourceArr.length; i++) {
        if (sourceArr[i] !== targetArr[i]) {
            // 这里有bug，检测不到undefined等情况
            sourceArr[i] = Number.isNaN(sourceArr[i]) ? 0 : sourceArr[i];
            targetArr[i] = Number.isNaN(targetArr[i]) ? 0 : targetArr[i];
            return sourceArr[i] - targetArr[i];
        }
    }
    return 0;
};

export const formatScore = (score = 0) => {
    if (score.toString().length > 6) {
        return `${(score / 1000).toFixed(2)}k`;
    }
    return score;
};

export const replaceAppName = (text: string) => {
    if (isSnack) {
        return text.replace(/Kwai/gi, 'Snack Video');
    }
    return text.replace(/Snack Video/gi, 'Kwai');
};

export const npx2vw = (npx: number) => {
    return `${(npx / 414) * 100}vw`;
};

export const generateRewards = (arr: any[]) => {
    const arr2 = arr.sort((a, b) => a.startPosition - b.startPosition);
    const res = [];
    for (let i = 0; i < arr2.length; i++) {
        const distance = arr[i].endPosition - arr[i].startPosition;
        for (let j = 0; j <= distance; j++) {
            res.push(arr[i].rewards);
        }
    }
    return res;
};

/**
 *
 * @param $mask 遮罩层id
 * @param $modal 需要滚动内容id
 */
export const stopScrollChaining = (mask: string, modal: string) => {
    const listenerOpts = { passive: false };
    const $mask = document.querySelector(mask) as Element;
    const $modal = document.querySelector(modal) as Element;
  $mask?.addEventListener(
      'touchmove',
      e => {
          e.preventDefault();
      },
      listenerOpts
  );
  let startY = 0;

  $modal?.addEventListener('touchstart', e => {
      startY = (e as TouchEvent)?.touches[0].pageY;
  });
  $modal?.addEventListener(
      'touchmove',
      e => {
          const modalHeight = $modal.clientHeight; // 元素可见高度
          const modalScrollHeight = $modal.scrollHeight; // 元素总高度
          const endY = (e as TouchEvent).touches[0].pageY;
          const delta = endY - startY;
          if (
              ($modal.scrollTop === 0 && delta > 0) ||
        ($modal.scrollTop + modalHeight === modalScrollHeight && delta < 0)
          ) {
              e.cancelable && e.preventDefault();
          }
      },
      listenerOpts
  );
};
export const byebye = (code: number) => {
    if (+code === 101) {
        window.location.href = '/events/end';
    }
};

export const getRandomInt = () => {
    return +Math.random().toString().slice(2, 8);
};

// 组合
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export function joinFormations(datas: any, formations: any) {
    const list: any = [];
    (formations || []).forEach((fs: any) => {
        const subList: any = [];
        (fs || []).forEach((val: any) => {
            const current =
        (datas || []).find(
            (v: any) => String(v.formationPlace) === String(val)
        ) ?? {};
            if (current) {
                const { substitute, playerId, playerName, shirtNumber } = current;
                const temp: Record<string, any> = {
                    playerId,
                    playerName,
                    shirtNumber,
                };
                if ((substitute || []).length) {
                    const sub = (substitute || [])[0];
                    const { timeMin, eventType } = sub || {};
                    temp.tipInfo = {
                        text: timeMin,
                    };
                    if (eventType === 'UP') {
                        // 上场
                        temp.tipInfo.type = 'up';
                    } else if (eventType === 'OFF') {
                        // 下场
                        temp.tipInfo.type = 'down';
                    }
                }
                subList.push(temp);
            }
        });
        list.push(subList);
    });
    return list;
}

// 数组对象排序
export const compare = function (prop: string, type: 'asc' | 'desc') {
    return function (obj1: any, obj2: any) {
        let val1 = obj1[prop];
        let val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
        }
        if (val1 < val2) {
            return type === 'asc' ? -1 : 1;
        }
        if (val1 > val2) {
            return type === 'asc' ? 1 : -1;
        }
        return 0;
    };
};
//
interface SortItem {
  advance: boolean; // 是否晋级
  points: number; // 积分
}
export const sortData = (a: SortItem, b: SortItem, type: 'asc' | 'desc') => {
    if (a.advance === b.advance) {
        if (a.points > b.points) {
            return type === 'asc' ? 1 : -1;
        }
        if (a.points < b.points) {
            return type === 'asc' ? -1 : 1;
        }
        return 0;
    }
    if (a.advance) {
        return type === 'asc' ? 1 : -1;
    }
    return type === 'asc' ? -1 : 1;
};

export const setPageError = (obj: {
  path: string;
  type: 'start' | 'end';
  live_type?: '0' | '1' | '2';
}) => {
    // 0 无
    const str = window.localStorage.getItem(obj.path) || '{}';
    const localStoreObj = JSON.parse(str);

    if (obj.type === 'start') {
        console.log('localStoreObj', obj.path, str);
        if (localStoreObj?.start && !localStoreObj.end) {
            // 上报
            sendLiveCustomLog({
                name: `${obj.path}-crash`,
                result_type: 1,
                extra_info: JSON.stringify({ start: localStoreObj?.start }),
            });
        }
        localStoreObj.start = +new Date();
        localStoreObj.end = 0;
        localStoreObj.live = obj.live_type;
        console.log('记录', JSON.stringify(localStoreObj));
    } else {
        localStoreObj.end = +new Date();
        console.log('推出', JSON.stringify(localStoreObj));
    }
    window.localStorage.setItem(obj.path, JSON.stringify(localStoreObj));
};
// 生成固定分隔1-10，11-20...
export const generateRankTab = (num:number, distance:number, start?:number) => {
    const count = Math.floor(num / distance);
    const obj:Record<string, number[]> = {};
    for (let index = 0; index < count; index++) {
        obj[index] = [distance * index + 1, distance * (index + 1)];

    }
    if (num / distance > count){
        obj[count] = [distance * count + 1, num];
    }
    const newObj:Record<string, number[]> = {};
    if (start){
        let c = 0;
        for (const key in obj) {
            if (obj[key][1] > start && obj[key][0] <= start){
                newObj[c] = [start, obj[key][1]];
            }
            if (obj[key][0] >= start && obj[key][1] >= start){
                newObj[c] = obj[key];
            }
            c++;
        }
        return newObj;
    }
    return obj;
};
